export var IdOfferType;
(function (IdOfferType) {
    IdOfferType[IdOfferType["Normal"] = 0] = "Normal";
    IdOfferType[IdOfferType["HCOffer"] = 1] = "HCOffer";
    IdOfferType[IdOfferType["GrowthFund"] = 2] = "GrowthFund";
})(IdOfferType || (IdOfferType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/IdOfferType.ts
// module id = 557
// module chunks = 3